import { Component, ViewChild } from '@angular/core';
import { AttendanceDeviceService } from '../../../Model/AttendanceDevice/attendance-device.service';
import { CommonService } from '../../../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-site-branch-mapping',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule, NgSelectModule],
  templateUrl: './site-branch-mapping.component.html',
  styleUrl: './site-branch-mapping.component.scss'
})
export class SiteBranchMappingComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Data: any[] = [];
  filter = {
    SelectType: 1,
    ESS_SiteWiseDeviceDetailsID: 0,
  }
  excelData = [] as any;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private attendanceDevice: AttendanceDeviceService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_SiteWiseDeviceDetailsSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_SiteWiseDeviceDetailsSelect() {
    this.isDisabled = true;
    this.Data = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } catch (e) { }
    this.attendanceDevice.ESS_SiteWiseDeviceDetailsSelect(this.filter).subscribe({
      next: (response) => {
        try {
          if (response.Table) {
            this.Data = Object.values(response.Table)
          }
          try {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
              this.dtTrigger.next(null);
            });
          } catch (e) { }

        } catch (e) { }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Delete(index: number) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to remove?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.attendanceDevice.ESS_SiteWiseDeviceDetails_InsertUpdate({
          SelectType: 'DD',
          ESS_SiteWiseDeviceDetailsID: this.Data[index].ESS_SiteWiseDeviceDetailsID,
          CodeType: this.Data[index].CodeType,
          BranchSiteCode: this.common.ToLowerCase(this.Data[index].CodeType) == 'site' ? this.Data[index].SiteCode : this.Data[index].BranchCode,
          DeviceSerialNumber: this.Data[index].SerialNumber,
          CompanyCode: this.Data[index].CompanyCode,
        }).subscribe({
          next: (response) => {
            if (response.Error_Code == '834') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.ESS_SiteWiseDeviceDetailsSelect();
                }
              });
            }
            else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }

            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  async ExcelDump() {
    this.excelData = [];
    if (this.Data.length > 0) {
      this.excelData = JSON.parse(JSON.stringify(this.Data));
      this.excelData.forEach(function (x: any) { delete x.sitemasterid, delete x.ESS_SiteWiseDeviceDetailsID});
      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.excelData);
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, 'ExcelSheet.xlsx');
    }
  }
}
